import { render, staticRenderFns } from "./PageHeaderComponent.vue?vue&type=template&id=262c3720&scoped=true&"
import script from "./PageHeaderComponent.vue?vue&type=script&lang=ts&"
export * from "./PageHeaderComponent.vue?vue&type=script&lang=ts&"
import style0 from "./PageHeaderComponent.vue?vue&type=style&index=0&id=262c3720&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "262c3720",
  null
  
)

export default component.exports